module.exports = __webpack_public_path__ + "static/img/2.fb12a08.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/eng/2.png
// module id = ncV8
// module chunks = 0